import axios from "axios";
import AuthenticationFailureHandler from "../../utils/AuthenticationFailureHandler";
import { getHeaders } from "../../utils/AuthorizationUtil";
import { BASE_URL } from "../../utils/EmpUtil";
import { is401, is404 } from "../../errors/ErrorConstants";

class TermsAndConditionsClient {
  static baseUrl = BASE_URL;

  static retrieveFile(user) {
    const url = `${
      this.baseUrl
    }/${user.generateResourcePath()}/terms-and-conditions`;

    return axios
      .get(url, getHeaders(user.token))
      .then((response) => response.data.file)
      .catch((error) => {
        if (is401(error) || is404(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static retrieveTermsAndConditionsHistory(user, currentMarket) {
    return this.getTermsAndConditions(
      user,
      "all-terms-and-conditions",
      currentMarket
    )
      .then((response) => response.data)
      .catch((error) => {
        if (is401(error) || is404(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static uploadTermsAndConditions(user, data, selectedMarket) {
    let url = `${
      this.baseUrl
    }/${user.generateResourcePath()}/terms-and-conditions`;

    url = url.concat(`?selectedMarket=${selectedMarket}`);

    return axios
      .post(url, data, getHeaders(user.token))
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static deleteTermsAndConditions(user, version, selectedMarket) {
    let url = `${
      this.baseUrl
    }/${user.generateResourcePath()}/delete-terms-and-conditions?version=${version}`;

    url = url.concat(`&selectedMarket=${selectedMarket}`);

    return axios.delete(url, getHeaders(user.token)).catch((error) => {
      if (is401(error)) {
        AuthenticationFailureHandler.execute();
      }
      return Promise.reject(error);
    });
  }

  static getTermsAndConditions(user, path, marketID = null) {
    let url;
    if (
      (user.userType === "dealer" || user.userType === "na_dealer") &&
      user.isMainDealer(user.dealerType) &&
      user.showAll
    ) {
      const commonIds = user.getCommonIdsWithoutSDLR();
      url = `${
        this.baseUrl
      }/${user.generateResourcePath()}/${path}?commonDealerIds=${commonIds}`;

      if (marketID !== null) {
        url = url.concat(`&selectedMarket=${marketID}`);
      }
    } else {
      url = `${this.baseUrl}/${user.generateResourcePath()}/${path}`;
      if (marketID !== null) {
        url = url.concat(`?selectedMarket=${marketID}`);
      }
    }
    return axios.get(url, getHeaders(user.token));
  }

  static saveDealerTermsAndConditionsAcceptance(
    user,
    termsAndConditions,
    isAccepted,
    commonIds
  ) {
    const url = `${
      this.baseUrl
    }/${user.generateResourcePath()}/terms-and-conditions-acceptance?dealerCommonIds=${commonIds}`;

    const data = {
      dealerUserId: user.userId,
      dealerId: user.dealerId,
      version: termsAndConditions.version,
      isAccepted: isAccepted,
    };

    return axios
      .post(url, data, getHeaders(user.token))
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }
}

export default TermsAndConditionsClient;
